import { formatDuration } from "@/lib/format";
import type { PersonWord, TimelineItem } from "./timeline/timeline-types";

export const CALL_STATUS_WORD: Record<string, string> = {
  completed: "answered",
  "no-answer": "not answered",
  busy: "busy",
  failed: "failed",
  canceled: "cancelled",
};

/** One line for an activity item, for the Overview's compact list. */
export function activityLine(
  item: TimelineItem,
  /** What the person's own messages are called. */
  personWord: PersonWord = "Customer",
): string {
  switch (item.kind) {
    case "whatsapp": {
      const who = item.direction === "in" ? `${personWord} wrote` : "We wrote";
      return `${who}: ${item.text || (item.templateName ? `Template ${item.templateName}` : "Media message")}`;
    }
    case "ticket":
      switch (item.event) {
        case "opened":
          return `Ticket ${item.ticketNumber} opened — ${item.title}`;
        case "closed":
          return `Ticket ${item.ticketNumber} closed — ${item.title}`;
        case "note":
          return `Note on ${item.ticketNumber}: ${item.text ?? ""}`;
        default:
          return `${item.from === "customer" || item.from === "champ" ? `${personWord} replied` : "We replied"} on ${item.ticketNumber}: ${item.text ?? item.title}`;
      }
    case "call": {
      const word = CALL_STATUS_WORD[item.status] ?? item.status;
      return `${item.direction === "in" ? "Incoming" : "Outgoing"} call, ${word}${item.durationSec > 0 ? ` · ${formatDuration(item.durationSec)}` : ""}${item.agentName ? ` · ${item.agentName}` : ""}`;
    }
    case "job":
      return `${item.outcome === "missed" ? "Missed job" : "Customer not at home"}${item.vehicleNumber ? ` · ${item.vehicleNumber}` : ""}`;
    case "note":
      return `Note: ${item.note.text}`;
  }
}
